const actions = {
  GET_PAYNET_BALANCE_BEGIN: 'GET_PAYNET_BALANCE_BEGIN',
  GET_PAYNET_BALANCE_SUCCESS: 'GET_PAYNET_BALANCE_SUCCESS',
  GET_PAYNET_BALANCE_ERR: 'GET_PAYNET_BALANCE_ERR',

  GET_PAYNET_MERCHANTS_BEGIN: 'GET_PAYNET_MERCHANTS_BEGIN',
  GET_PAYNET_MERCHANTS_SUCCESS: 'GET_PAYNET_MERCHANTS_SUCCESS',
  GET_PAYNET_MERCHANTS_ERR: 'GET_PAYNET_MERCHANTS_ERR',

  GET_PAYNET_PRODUCTS_BEGIN: 'GET_PAYNET_PRODUCTS_BEGIN',
  GET_PAYNET_PRODUCTS_SUCCESS: 'GET_PAYNET_PRODUCTS_SUCCESS',
  GET_PAYNET_PRODUCTS_ERR: 'GET_PAYNET_PRODUCTS_ERR',

  getPaynetBalanceBegin: () => {
    return {
      type: actions.GET_PAYNET_BALANCE_BEGIN,
    };
  },

  getPaynetBalanceSuccess: (data) => {
    return {
      type: actions.GET_PAYNET_BALANCE_SUCCESS,
      data,
    };
  },

  getPaynetBalanceErr: (err) => {
    return {
      type: actions.GET_PAYNET_BALANCE_ERR,
      err,
    };
  },

  getPaynetMerchantsBegin: () => {
    return {
      type: actions.GET_PAYNET_MERCHANTS_BEGIN,
    };
  },

  getPaynetMerchantsSuccess: (data) => {
    return {
      type: actions.GET_PAYNET_MERCHANTS_SUCCESS,
      data,
    };
  },

  getPaynetMerchantsErr: (err) => {
    return {
      type: actions.GET_PAYNET_MERCHANTS_ERR,
      err,
    };
  },

  getPaynetProductsBegin: () => {
    return {
      type: actions.GET_PAYNET_PRODUCTS_BEGIN,
    };
  },

  getPaynetProductsSuccess: (data) => {
    return {
      type: actions.GET_PAYNET_PRODUCTS_SUCCESS,
      data,
    };
  },

  getPaynetProductsErr: (err) => {
    return {
      type: actions.GET_PAYNET_PRODUCTS_ERR,
      err,
    };
  },
};

export default actions;
